import { SlideTheme } from '@/types/slides'

export const theme: SlideTheme = {
  themeColor: '#0153fd',
  fontColor: '#000000',
  fontName: 'Noto Sans S Chinese Regular',
  backgroundColor: '#fff',
  fontSize:''
}